<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-search"
        :label="$t('Buscar')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      hide-headers
      :headers="headers"
      :items="companies"
      :items-per-page="1"
      :search="search"
    >
      <template v-slot:items="props">
        <tr
          style="cursor: pointer"
          :active="props.selected"
          @click="changeClavedat(props.item.CLAVEDAT)"
        >
          <td
            :class="{
              'primary--text': props.item.CLAVEDAT == $store.state.clavedat,
            }"
          >
            {{ props.item.APELNOM }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Empresa',
          align: 'left',
          sortable: false,
          value: 'APELNOM',
        },
      ],
    };
  },
  computed: {
    companies() {
      let result = [];
      if (
        this.$store.state.hasOwnProperty('user') &&
        this.$store.state.user.hasOwnProperty('customer_profile') &&
        this.$store.state.user.customer_profile &&
        this.$store.state.user.customer_profile.hasOwnProperty('fiscal_data') &&
        this.$store.state.user.customer_profile.fiscal_data &&
        Array.isArray(this.$store.state.user.customer_profile.fiscal_data)
      ) {
        result = this.$store.state.user.customer_profile.fiscal_data;
      }
      return result;
    },
  },
  methods: {
    changeClavedat(clavedat) {
      this.$store.dispatch('changeClavedat', clavedat);
      this.$router.go('/dashboard');
    },
  },
};
</script>

<style></style>
